import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import {
  Section,
  Hr,
  Ul,
  Li,
  AnswerBox,
  Question,
  Answer,
} from './faq.style';

import { APPLICANTS_TITLE } from '../../../constants/titles';

const ApplicantsFaq = ({ setTitle }) => {

  setTitle(APPLICANTS_TITLE);

  return (
    <div>
      <Section>
        <Ul>
          <Link to="#question1" smooth={true}>
            <Li>How do I apply for a role?</Li>
          </Link>
          <Link to="#question2" smooth={true}>
            <Li>Why should I use your jobs board?</Li>
          </Link>
          <Link to="#question3" smooth={true}>
            <Li>How can I get help applying for a role?</Li>
          </Link>
          <Link to="#question4" smooth={true}>
            <Li>I’m not sure I’m ready to apply, I feel nervous!</Li>
          </Link>
          <Link to="#question5" smooth={true}>
            <Li>Why aren’t there more roles?</Li>
          </Link>
          <Link to="#question6" smooth={true}>
            <Li>Got any tips?</Li>
          </Link>
        </Ul>
      </Section>
      <Hr />
      <Section>
        <AnswerBox>
          <Question id="question1">How do I apply for a role?</Question>
          <Answer>
            Please apply directly with the employer, all roles listed will take
            you through to the employer site where you can find out how to
            apply. Please check the rest of the site for ideas of how you can
            work with us to use your talents and ideas into cash. You could be
            teaching an employer about how you see society working or about your
            identity, or you could join us in telling brands what we want from
            them. Register to hear our news, or ask to join our programme.
          </Answer>
        </AnswerBox>
        <AnswerBox>
          <Question id="question2">Why should I use your jobs board?</Question>
          <Answer>
            Because we want to make work better for everyone. We are a social
            enterprise which means we make money, but our priority is you first.
            Our reason to exist is to position you as an expert with employers,
            and to end discrimination. Come talk to us to hear more.
          </Answer>
        </AnswerBox>
        <AnswerBox>
          <Question id="question3">
            How can I get help applying for a role?
          </Question>
          <Answer>
            We don’t help with specific jobs board opportunities BUT we have an
            amazing talent programme. Come join us to unlock your own skills and
            to access a whole other world of work opportunities. Our programme
            ends with the opportunity for everyone to visit an employer and get
            paid to teach them about the best way to manage you. Contact us to
            apply and join our programme.
          </Answer>
        </AnswerBox>
        <AnswerBox>
          <Question id="question4">
            I’m not sure I’m ready to apply, I feel nervous!
          </Question>
          <Answer>
            Write down a list of 3 things you taught someone else in the last
            year. Remember: you already have a whole range of talents and
            skills. It’s just a case of finding the right employer to nurture
            them. If you’re interested in joining our talent programme (you are
            the talent, we just find ways to tease it out of you) then please
            get in touch. We would love to work with you.
          </Answer>
        </AnswerBox>
        <AnswerBox>
          <Question id="question5">Why aren’t there more roles?</Question>
          <Answer>
            We only list employers we think are committed to genuinely nurturing
            the talent they bring on board. Lots of companies include messages
            in their marketing about what they are doing to have more diverse
            organisations. We have seen how in reality this can still mean
            limited opportunities for different types of people to progress, and
            even that new hires experience bias and discrimination. The
            employers on our jobs board have started their work to understand
            how their culture affects everyone they employ.
          </Answer>
        </AnswerBox>
        <AnswerBox>
          <Question id="question6">Got any tips?</Question>
          <Answer>
            Start with what you are good at. Write down a list. Ask a friend,
            ask your family to comment on it. We bet they will come up with some
            more talents you are being too shy about. Think about the way you
            tell the story of what you are good at - how could you apply it to
            the job you are applying for?
          </Answer>
        </AnswerBox>
      </Section>
    </div>
  );
};

export default ApplicantsFaq;
